import { AppBar, Box, colors, Divider, Link, Toolbar } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import Logo from "src/components/Logo";
import { useSelector } from "src/store";

const TopBar = ({ className, ...rest }) => {
  const { t } = useTranslation();
  const { adminMode } = useSelector((state) => state.settings);
  const { currentCustomer } = useSelector((state) => state.customers);

  return (
    <AppBar
      className={className}
      elevation={0}
      sx={{
        backgroundColor: adminMode ? colors.grey[900] : colors.common.white,
        color: adminMode ? colors.common.white : colors.grey[900],
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
      {...rest}
    >
      <Toolbar sx={{ minHeight: 72 }}>
        <RouterLink
          to={currentCustomer ? `/${currentCustomer.shortname}` : `/`}
        >
          <Logo styles={{ width: "9rem" }} />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />
        <Link
          color={adminMode ? "secondary" : "inherit"}
          component={RouterLink}
          to="/app"
          underline="none"
          variant="body2"
          sx={{ fontWeight: 600 }}
        >
          {t("Panel")}
        </Link>
        <Divider orientation="vertical" flexItem sx={{ ml: 2 }} />
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
};

export default TopBar;
